import { gql } from 'apollo-angular';

export const LIST_PRIVATE_TRANSIT_CARGO_REQUESTS = gql`
  query ListPrivateTransitCargoRequests(
    $pageableParam: PageableParamInput
    $vesselNominationUuid: UUID
    $supplierCompanyUuid: UUID
    $statuses: [String]
  ) {
    listPrivateTransitCargoRequests(
      pageableParam: $pageableParam
      vesselNominationUuid: $vesselNominationUuid
      supplierCompanyUuid: $supplierCompanyUuid
      statuses: $statuses
    ) {
      totalElements
      totalPages
      number
      size
      content {
        active
        actualSubmittedAt
        approvedPrivateQuantityMt
        attachableDiscriminator
        baselineAllocationReferenceNo
        baselineCapturedAt
        baselineCargoLineUpReferenceNo
        baselineContractReferenceNo
        baselineFirstDeliveryDate
        baselineImoNumber
        baselineLastDeliveryDate
        baselineTenderLotReferenceNo
        baselineTenderedPremium
        baselineTenderedQuantityMt
        baselineVesselName
        capacitySufficient
        companyName
        currentBpsCargoMt
        dilutedPremium
        fullCargoQuantityMt
        lateDispositionReason
        lateRequest
        otherApprovedCargoMt
        otherAttachmentName
        preliminarySpareCapacityMt
        proposedFullCargoMt
        proposedLoadDischargeSequence
        receiptNumber
        registrationType
        requestDeadlineAt
        requestReason
        requestStatus
        requestVersion
        segregationCompatibilityNotes
        staleReason
        stowagePlanReference
        totalRequestedMt
        type
        uuid
        vesselUsableCapacityMt
        withdrawalReason
        withdrawnAt
      }
    }
  }
`;

export const GET_PRIVATE_TRANSIT_CARGO_REQUEST = gql`
  query GetPrivateTransitCargoRequest($requestUuid: UUID) {
    getPrivateTransitCargoRequest(requestUuid: $requestUuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        actualSubmittedAt
        approvedPrivateQuantityMt
        baselineAllocationReferenceNo
        baselineCapturedAt
        baselineCargoLineUpReferenceNo
        baselineContractReferenceNo
        baselineFirstDeliveryDate
        baselineImoNumber
        baselineLastDeliveryDate
        baselineTenderLotReferenceNo
        baselineTenderedPremium
        baselineTenderedQuantityMt
        baselineVesselName
        capacitySufficient
        companyName
        currentBpsCargoMt
        decisionBlockReason
        decisionOutcome
        declarantName
        declarantTitle
        declarationAcceptedAt
        declarationAuthorisedSignatory
        declarationNoPrejudiceToBps
        declarationSupplierResponsibility
        declarationUndeclaredAtBid
        dilutedPremium
        discriminator
        effectiveAllocationVersion
        fullCargoQuantityMt
        lateRequest
        otherApprovedCargoMt
        otherAttachmentName
        preliminarySpareCapacityMt
        proposedFullCargoMt
        proposedLoadDischargeSequence
        receiptNumber
        registrationType
        requestDeadlineAt
        requestReason
        requestStatus
        requestVersion
        segregationCompatibilityNotes
        staleReason
        stowagePlanReference
        totalRequestedMt
        type
        uuid
        vesselUsableCapacityMt
        withdrawalReason
        withdrawnAt
        attachments {
          active
          id
          minioObjectName
          uuid
          attachable {
            attachableDiscriminator
            bucketName
            id
            otherAttachmentName
            registrationType
            uuid
          }
          attachmentType {
            active
            fileSize
            fileType
            id
            kind
            name
            uuid
          }
        }
        parcels {
          active
          notifyPartyContact
          notifyPartyName
          parcelReference
          productGrade
          quantityMt
          shipperName
          transitClassification
          transitCountryName
          transitCountryId
          transitCountryCode
          uuid
          product {
            productName
            productCode
            uuid
            id
          }
         consignee {
            uuid
            id
            countryName
            countryId
            companyName
          }
          destinationTerminal {
            terminalName
            uuid
            active
          }
        }
        lateDispositionReason
        vesselNomination {
          vesselName
          uuid
          active
        }
      }
    }
  }
`;

export const SAVE_PRIVATE_TRANSIT_CARGO_REQUEST = gql`
  mutation SavePrivateTransitCargoRequest($input: PrivateTransitCargoReqInput) {
    savePrivateTransitCargoRequest(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        uuid
      }
    }
  }
`;

export const UPDATE_PRIVATE_TRANSIT_CARGO_REQUEST = gql`
  mutation UpdatePrivateTransitCargoRequest($input: PrivateTransitCargoUpdateReqInput) {
    updatePrivateTransitCargoRequest(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        uuid
      }
    }
  }
`;

export const SUBMIT_PRIVATE_TRANSIT_CARGO_REQUEST = gql`
  mutation SubmitPrivateTransitCargoRequest($input: PrivateTransitCargoSubmitReqInput) {
    submitPrivateTransitCargoRequest(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        uuid
      }
    }
  }
`;

export const WITHDRAW_PRIVATE_TRANSIT_CARGO_REQUEST = gql`
  mutation WithdrawPrivateTransitCargoRequest($input: PrivateTransitCargoWithdrawReqInput) {
    withdrawPrivateTransitCargoRequest(input: $input) {
      code
      data {
        uuid
        type
        active
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const ACKNOWLEDGE_PRIVATE_TRANSIT_CARGO_CONDITIONS = gql`
  mutation AcknowledgePrivateTransitCargoConditions(
    $input: PrivateTransitCargoAcknowledgementReqInput
  ) {
    acknowledgePrivateTransitCargoConditions(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        uuid
      }
    }
  }
`;

export const RESUBMIT_PRIVATE_TRANSIT_CARGO_FOR_APPROVAL = gql`
  mutation ResubmitPrivateTransitCargoForApproval($requestUuid: UUID) {
    resubmitPrivateTransitCargoForApproval(requestUuid: $requestUuid) {
      code
      data {
        active
        uuid
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;


